module.exports = __webpack_public_path__ + "assets/img/9期权.a1c427cd.png";